// 自动导入各包模块图标
// prettier-ignore
const modules = {}

try {
  const req = require.context('./', true, /\.js$/)

  req.keys().forEach((key) => {
    if (key !== './index.js') {
      const name = key.replace('./', '').replace('.js', '')
      modules[name] = req(key).default
    }
  })
} catch (e) {
  console.warn('require.context not available, using manual import method')
}

export function getWords(packageName) {
  const tempWordsObj = {}

  try {
    const wordsMap = modules[packageName]
    if (wordsMap) {
      Object.keys(wordsMap).forEach((wordKey) => {
        tempWordsObj[wordKey] = wordsMap[wordKey]()
      })
    }
  } catch (e) {
    console.warn('text error')
  }

  return tempWordsObj
}

export default getWords
